import axios from "axios";
import { searchParty } from "./searchParty";
import { AlertRequest, ErrorRequest, QuestionRequest } from "../Components/Alerts/Buy";
import { markFavorite } from "./markFavorite";

var formatter = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

async function requestOffer(context, sale_order_id) {
  const { oportunity, id_op, origin } = context;

  const party = searchParty(oportunity, "Asegurado");

  const insurable_object = oportunity.risk_in.insurable_objects[0];

  const insurable_obj = insurable_object.identification;

  const partner_name =
    party.party_type === "person"
      ? party.person.firstname + " " + party.person.lastname
      : party.organization.name;

  const partner_document =
    party.party_type === "person"
      ? party.person.identification_number
      : party.organization.identification_number;

  const contact_data =
    party.party_type === "person"
      ? party.person.contact_data[0]
      : party.organization.contact_data[0];

  const partner_phone = contact_data.contact_info.phone;

  const email_to = oportunity.broker.email;

  const business_line = oportunity.risk_in?.business_line
    ?.toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());

  const policy = context.policies.find(
    (policy) => policy.id_db === sale_order_id
  );

  const product = policy?.products[0];

  const offer_name = product?.name
    ?.toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());

  const offer_price = formatter.format(policy?.total_price);

  const offer_insurer = product?.manufacturer
    ?.toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());

  const body = {
    jsonrpc: "2.0",
    method: "call",
    id: 1,
    params: {
      data: {
        sale_order_id: sale_order_id,
        id_op: id_op,
        email_to: email_to,
        offer_name: offer_name,
        offer_price: offer_price,
        offer_insurer: offer_insurer,
        business_line: business_line,
        insurable_obj: insurable_obj,
        partner_name: partner_name,
        partner_document: partner_document,
        partner_phone: partner_phone || " ",
      },
    },
  };

  return await axios
    // .post(`https://cencosud.co.agm-dev.com/crm/requested_quote`, body)
    .post(`${origin}/crm/requested_quote`, body)
    .then((res) => res)
    .catch((err) => console.log(err));
}

const buyCallback = (urlSearch) => {
  //! si esta en detalles o comparativa, se redirige a la pagina anterior y recarga
  const URLSearchParam = new URLSearchParams(urlSearch);
  var url = window.location.pathname;
  var urlParts = url.split("/");
  var lastRoute = urlParts[urlParts.length - 1];
  let newPath = "";

  if (lastRoute == "comparative" || lastRoute == "details") {
    newPath = url.slice(0, url.lastIndexOf("/"));
    newPath = newPath === "" ? "/" : newPath;
    newPath = newPath + urlSearch;
  } else {
    newPath = url + urlSearch;
  }

  if (!URLSearchParam.get("noCache")) {
    newPath = newPath + "&noCache=true";
  }

  //! recarga la pagina
  window.history.pushState(null, null, newPath);
  window.location.reload();
};

const ExecuteOffer = (context, id_db) => {
  context.setLoading(true);
  //! se marca como favorito
  markFavorite(id_db)
    .then((res) => {
      console.log("Mark favorite", res);
      if (res.data.success) {
        //! se hace la llamada a la api para solicitar la oferta
        requestOffer(context, id_db);
        AlertRequest(() => buyCallback(context.urlSearch));
      } else {
        ErrorRequest(() => buyCallback(context.urlSearch));
      }
    })
    .catch((err) => {
      console.log("Mark favorite", err);
      ErrorRequest(() => buyCallback(context.urlSearch));
    });
};

const onRequestOffer = (context, id_db) => {
  //! se muestra el modal de confirmacion
  QuestionRequest((value) => {
    if (value == "Aceptar") {
      ExecuteOffer(context, id_db);
    }
  });
};

export { onRequestOffer };
